import axios from "axios";
import React, { useEffect, useState } from "react";
import ModalPortal from "./ModalPortal";
import aqiData from "./../data/aqiData.json";
import aqiIconGood from "./../img/src_icons_green.svg";
import aqiIconBad from "./../img/src_icons_red.svg";
// import { Tooltip } from "react-leaflet";
import { Chart as ChartJS, BarElement, CategoryScale, Tooltip, LinearScale } from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip
  )

const MainModal = (props) => {
    console.log('po hapna', props);
    // console.log('aqidata', aqiData);
    const [type, setType] = useState("list"); // ModalViewType
    const dateNow = new Date();
// get messages from json file based on id 
    function getAqiMsg(id) {
        let msg = aqiData?.map((el,i) => {
            if (el.index === id){
            return el.name_al;
            }
        });
        // console.log("mapData", msg);
        return msg
        }
// get day name based on locale
    function getDayName(date = new Date(), locale = 'sq-AL') {
        return date.toLocaleDateString(locale, {weekday: 'long'});
      }
    
useEffect(()=>{
    console.log("type",type);
   

},[type]);
// #####################################     
// Configuring Graph Data
// #####################################
// SO2 Graf Preparation
const grafSo2 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'SO2',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.so2
        })
    }]
}
// NO Graf Preparation
const grafNo = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'NH3',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.no
        })
    }]
}
// NH3 Graf Preparation
const grafNh3 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'NH3',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.nh3
        })
    }]
}
// Co Graf Preparation
const grafCo = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'CO',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.co
        })
    }]
}
// no2 Graf Preparation
const grafNo2 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'NO2',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.no2
        })
    }]
}

// O3 Graf Preparation
const grafO3 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'O3',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.pm10
        })
    }]
}
// PM10 Graf Preparation
const grafPm10 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'PM2.5',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.pm10
        })
    }]
}
// PM2.5 Graf Preparation
const grafPm25 = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'PM2.5',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.components.pm2_5
        })
    }]
}
// aqi inded Graf Preparation
const grafIndex = {
    labels: props?.timeData?.list?.map((el) => {
        let dt = new Date(el.dt * 1000);
        let stringDt = dt.toISOString();
        return stringDt.slice(0,16)?.replace('T', ' ')}),
    datasets: [{
        label: 'AQI',
        backgroundColor: '#d1d1d1',
        hoverBackgroundColor: '#089000',
        // borderColor: 'rgba(0,0,0,1)',
        // borderWidth: 2,
        data: props?.timeData?.list?.map((chart) => {
            return chart.main.aqi
        })
    }]
}
console.log("grafIndex",grafIndex);

    if (props?.isOpen) {

        return (
            <ModalPortal wrapperId={"ReportModal-" + props?.cityId} className='mymodal'>

                <div className='mymodal'
                   
                >
                    <button className="exitModal" style={{right: type !== "list" ? "74%" : "49%"}} onClick={()=>{props.handleClose(); setType("list")}}><i className="fa fa-times" /></button>
                        <div className="modalActionButtonWrapper" >
                            <button className="modalButton" onClick={()=> {setType("list")}}> <i className="fa fa-list" /></button>
                            <button className="modalButton" onClick={()=> {setType("chart")}}> <i className="fa fa-bar-chart fa-rotate-270" /></button>
                            <button className="modalButton" onClick={()=> {setType("table")}}> <i className="fa fa-table" /></button>
                        </div>
                    <div className='mymodal-wrapper'  style={{width: type !== "list" ? "75%" : "50%"}}>
                       <div className="modalTitle bg-light "> Parashikimi 3 ditorë i kualitetit të ajrit per qytetin: <h3>{props.modalName?.toUpperCase()}</h3> për datën {dateNow.toISOString()?.slice(0,10)}</div>
                       { type === 'list' && props?.timeData?.list.map((el , index) => {
                        let dt = new Date(el.dt * 1000);
                        let stringDt = dt.toISOString();
                        return (
                        <div className={ 
                            el?.main?.aqi === 1 ? "bg-success text-light stickyComponent" : ""||
                             el?.main?.aqi === 2 ? "bg-warning text-light stickyComponent": "" || 
                             el?.main?.aqi === 3 ? "bg-danger text-light stickyComponent": "" } key={index} >
                           <div className="col-3 ">                            
                                <div className="time col p-2 bg-dark rounded-pill pl-4"><i className="fa fa-clock"/> {stringDt.slice(11,16)}</div>
                                <img src={ el.main.aqi ===1 ? aqiIconGood : aqiIconBad } width={"100%"} className="pt-2 pb-2"/>
                            <div className="aqiIndex col p-2 bg-dark rounded-pill pl-4">Indexi : { el.main.aqi}</div>
                                
                           </div>
                           <div className="col-9">
                            <div className="row">
                            <div className="date col p-2 bg-dark rounded-pill pl-4"><i className="fa fa-calendar"/> {stringDt.slice(0,10) }</div>
                            <div className="date col p-2 bg-dark rounded-pill pl-4"><i className="fa fa-calendar"/> { getDayName(dt).toUpperCase()}</div>
                            <div className="col-12">{ getAqiMsg(el?.main?.aqi)}</div>
                            <div className="row p-1">
                                <div className="col-6">

                                <div className="col-12">CO : { el.components.co} μg/m3</div>
                                <div className="col-12">NO : { el.components.no} μg/m3</div>
                                <div className="col-12">No2 : { el.components.no2} μg/m3</div>
                                <div className="col-12">O3 : { el.components.o3} μg/m3</div>
                                </div>
                                <div className="col-6">
                                <div className="col-12">SO2 : { el.components.so2} μg/m3</div>
                                <div className="col-12">Pm2.5 : { el.components.pm2_5} μg/m3</div>
                                <div className="col-12">Pm10 : { el.components.pm10} μg/m3</div>
                                <div className="col-12">NH3 : { el.components.nh3} μg/m3</div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>
                        
                        )
                       }) }
                       {/* Chart modal type */}
                       { type === 'chart' && 
                       <>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                            <h5>Indexi i Qualitetit te Ajrit</h5>
                            <Bar  key={"grafIndex"} height={100} data={grafIndex}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>Pm 2.5</h5>
                            <Bar key={"grafPm25"} height={100} data={grafPm25}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>Pm 10</h5>
                            <Bar key={"grafPm25"} height={100} data={grafPm10}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>O3</h5>
                            <Bar key={"grafPm25"} height={100} data={grafO3}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>No2</h5>
                            <Bar key={"grafPm25"} height={100} data={grafNo2}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>So2</h5>
                            <Bar key={"grafPm25"} height={100} data={grafSo2}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>Co</h5>
                            <Bar key={"grafPm25"} height={100} data={grafCo}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>Nh3</h5>
                            <Bar key={"grafPm25"} height={100} data={grafNh3}  options={{ maintainAspectRatio: true }} />
                        </div>
                       <div className="bg-light pr-5 pl-4 pt-4 pb-5">
                       <h5>No</h5>
                            <Bar key={"grafPm25"} height={100} data={grafNo}  options={{ maintainAspectRatio: true }} />
                        </div>
                        
                        </>}
                        {/* table modal type */}
                        { type === 'table' && <div className=" bg-light table-responsive">
                        <table class="table">
                            <thead class="thead-dark sticky-top">
                                <tr>
                                {/* <th scope="col">Vendi</th> */}
                                {/* <th scope="col">Lat</th>
                                <th scope="col">Lng</th> */}
                                <th scope="col">Koha</th>
                                <th scope="col">AQI</th>
                                <th scope="col">Pm 2.5</th>
                                <th scope="col">Pm 10</th>
                                <th scope="col">O3</th>
                                <th scope="col">No2</th>
                                <th scope="col">No</th>
                                <th scope="col">Co</th>
                                <th scope="col">Nh3</th>
                                </tr>
                            </thead>
                            <tbody>
                              { props?.timeData?.list?.map((el,index)=> {
                                let dt = new Date(el.dt * 1000);
                                let stringDt = dt.toISOString();
                                 return(<tr key={index}>
                                    {/* <th scope="row">{props?.modalName}</th> */}
                                    <td>{stringDt?.replace("T", " ")?.slice(0,16)}</td>
                                    <td>{el.main.aqi}</td>
                                    <td>{el.components.pm2_5}</td>
                                    <td>{el.components.pm10}</td>
                                    <td>{el.components.o3}</td>
                                    <td>{el.components.no2}</td>
                                    <td>{el.components.no}</td>
                                    <td>{el.components.co}</td>
                                    <td>{el.components.nh3}</td>
                                    
                                    </tr>)
                              }) 
                            }
                            </tbody>
                            </table>

                            </div>}
                    </div >
                </div >
            </ModalPortal >
        )
    } else return null

}


export default MainModal;